export const ADJECTIVES = [
  "ablaze",
  "able",
  "abrupt",
  "abstract",
  "abundant",
  "academic",
  "accepting",
  "acclaimed",
  "acoustic",
  "active",
  "adaptable",
  "adept",
  "adjacent",
  "admired",
  "adorable",
  "adored",
  "advanced",
  "aerial",
  "affable",
  "affinity",
  "agile",
  "agreeable",
  "alert",
  "alive",
  "alluring",
  "alpine",
  "amazing",
  "ambient",
  "amiable",
  "ample",
  "amused",
  "amusing",
  "ancient",
  "angelic",
  "angular",
  "animated",
  "annual",
  "antique",
  "appealing",
  "applied",
  "aquatic",
  "archival",
  "ardent",
  "arid",
  "aromatic",
  "articulate",
  "artistic",
  "assured",
  "astral",
  "astute",
  "athletic",
  "atomic",
  "attentive",
  "audible",
  "august",
  "austere",
  "authentic",
  "autumnal",
  "avian",
  "avid",
  "awake",
  "aware",
  "awesome",
  "axial",
  "balanced",
  "beaming",
  "beloved",
  "benign",
  "benthic",
  "best",
  "binding",
  "bionic",
  "blazing",
  "blended",
  "blessed",
  "blissful",
  "blooming",
  "bold",
  "boreal",
  "botanic",
  "bouncy",
  "bountiful",
  "braided",
  "brainy",
  "brassy",
  "brave",
  "breezy",
  "bridged",
  "brief",
  "bright",
  "brilliant",
  "brisk",
  "brittle",
  "broad",
  "brushed",
  "bubbly",
  "bucolic",
  "buoyant",
  "burnished",
  "bustling",
  "busy",
  "calcite",
  "calm",
  "candid",
  "capable",
  "carefree",
  "careful",
  "caring",
  "carved",
  "cascading",
  "casual",
  "cellular",
  "central",
  "ceramic",
  "certain",
  "charming",
  "cheerful",
  "cheery",
  "chief",
  "choice",
  "choral",
  "chromatic",
  "civic",
  "civil",
  "clad",
  "classic",
  "classy",
  "clean",
  "clear",
  "clement",
  "clever",
  "climbing",
  "clipped",
  "clockwise",
  "close",
  "coastal",
  "coherent",
  "collected",
  "colonial",
  "columnar",
  "comfy",
  "comical",
  "common",
  "communal",
  "compact",
  "complex",
  "composed",
  "concise",
  "concrete",
  "conducive",
  "confident",
  "connected",
  "constant",
  "content",
  "cool",
  "cordial",
  "corrugated",
  "cosmic",
  "county",
  "courtly",
  "cozy",
  "crafty",
  "creative",
  "crescent",
  "crisp",
  "crisscross",
  "crustal",
  "cubic",
  "cuddly",
  "cultured",
  "cunning",
  "curated",
  "curious",
  "current",
  "curved",
  "curvy",
  "cute",
  "cyclic",
  "dainty",
  "dampened",
  "dandy",
  "dapper",
  "daring",
  "darling",
  "dashing",
  "daytime",
  "dazzling",
  "decent",
  "deciduous",
  "decimal",
  "deckled",
  "deeded",
  "deep",
  "definite",
  "deft",
  "delicate",
  "delighted",
  "deltaic",
  "dense",
  "departed",
  "derived",
  "designed",
  "detailed",
  "devoted",
  "devout",
  "diagonal",
  "digital",
  "diligent",
  "direct",
  "distinct",
  "diurnal",
  "diverse",
  "divine",
  "docile",
  "domed",
  "domestic",
  "dormant",
  "dotted",
  "double",
  "downy",
  "dozing",
  "drafted",
  "dreamy",
  "drifting",
  "driven",
  "dual",
  "dulcet",
  "durable",
  "dutiful",
  "dynamic",
  "eager",
  "earnest",
  "earthen",
  "earthy",
  "eastern",
  "easy",
  "eclectic",
  "edged",
  "edgy",
  "educated",
  "effusive",
  "eighth",
  "elastic",
  "elated",
  "elected",
  "elegant",
  "elite",
  "eloquent",
  "embossed",
  "emergent",
  "eminent",
  "empirical",
  "enchanted",
  "enclosed",
  "endemic",
  "endless",
  "endowed",
  "engaged",
  "engraved",
  "enormous",
  "ensured",
  "entire",
  "epic",
  "equal",
  "equine",
  "equipped",
  "eroded",
  "esoteric",
  "essential",
  "esteemed",
  "esthetic",
  "eternal",
  "etheric",
  "ethical",
  "euclidean",
  "even",
  "evergreen",
  "evident",
  "evolved",
  "exact",
  "exalted",
  "excellent",
  "excited",
  "exciting",
  "exotic",
  "expansive",
  "expert",
  "express",
  "exquisite",
  "extended",
  "exterior",
  "exuberant",
  "fabled",
  "fabulous",
  "faceted",
  "factored",
  "factual",
  "fair",
  "faithful",
  "familiar",
  "famous",
  "fancy",
  "fantastic",
  "faraway",
  "fast",
  "fathomed",
  "favored",
  "favorite",
  "fearless",
  "feathered",
  "federal",
  "feline",
  "fervent",
  "festive",
  "fibrous",
  "fierce",
  "figured",
  "filtered",
  "fine",
  "finite",
  "firm",
  "firsthand",
  "fit",
  "fixed",
  "flagged",
  "flanked",
  "flannel",
  "flashy",
  "flat",
  "flecked",
  "fledged",
  "fleeting",
  "flexible",
  "floating",
  "floral",
  "flowing",
  "fluent",
  "fluffy",
  "flying",
  "focal",
  "focused",
  "folded",
  "fond",
  "forested",
  "forked",
  "formal",
  "forward",
  "founding",
  "fractional",
  "fragrant",
  "framed",
  "frank",
  "free",
  "freeform",
  "fresh",
  "friendly",
  "frosted",
  "frozen",
  "frugal",
  "fruity",
  "fulfilled",
  "full",
  "fun",
  "funky",
  "funny",
  "galactic",
  "gallant",
  "game",
  "gathered",
  "gauged",
  "general",
  "generous",
  "genetic",
  "genial",
  "genteel",
  "gentle",
  "genuine",
  "geodesic",
  "geologic",
  "germinal",
  "gifted",
  "giving",
  "glacial",
  "glad",
  "gleaming",
  "gleeful",
  "global",
  "glorious",
  "glossed",
  "glowing",
  "golden",
  "good",
  "gothic",
  "graceful",
  "gracious",
  "graded",
  "grafted",
  "grand",
  "graphic",
  "grassy",
  "grateful",
  "graveled",
  "great",
  "gridded",
  "grounded",
  "grouped",
  "growing",
  "guarded",
  "guided",
  "guilded",
  "gutsy",
  "habitual",
  "halcyon",
  "handmade",
  "handy",
  "happy",
  "hardened",
  "hardy",
  "harmless",
  "harmonic",
  "healing",
  "healthy",
  "hearty",
  "hedged",
  "helpful",
  "herbal",
  "heroic",
  "hidden",
  "high",
  "highland",
  "historic",
  "holistic",
  "homespun",
  "honed",
  "honest",
  "hopeful",
  "horizonal",
  "horned",
  "hourly",
  "huge",
  "humble",
  "humming",
  "humorous",
  "hushed",
  "hybrid",
  "hymnal",
  "ideal",
  "immense",
  "immortal",
  "immune",
  "imperial",
  "inclined",
  "indexed",
  "indoor",
  "inertial",
  "infinite",
  "inflected",
  "informed",
  "inlaid",
  "inland",
  "innate",
  "inner",
  "innocent",
  "inscribed",
  "inspired",
  "instant",
  "intact",
  "integral",
  "intense",
  "intent",
  "interim",
  "internal",
  "intimate",
  "intrepid",
  "inventive",
  "invested",
  "inviting",
  "invoked",
  "ionic",
  "iridescent",
  "isometric",
  "itinerant",
  "ivied",
  "jagged",
  "jaunty",
  "jazzy",
  "jeweled",
  "jocular",
  "joined",
  "jolly",
  "journeyed",
  "jovial",
  "joyful",
  "joyous",
  "jubilant",
  "judicious",
  "juggled",
  "juicy",
  "just",
  "keen",
  "kind",
  "kindred",
  "kinetic",
  "kingly",
  "knitted",
  "knowing",
  "known",
  "labeled",
  "lacquered",
  "laminar",
  "landlocked",
  "large",
  "lasting",
  "lateral",
  "latticed",
  "lavish",
  "lawful",
  "layered",
  "leading",
  "leafy",
  "lean",
  "learned",
  "ledger",
  "legal",
  "legible",
  "lenient",
  "level",
  "leveled",
  "lexical",
  "lifted",
  "light",
  "ligneous",
  "likable",
  "liked",
  "lilting",
  "limber",
  "limelight",
  "lined",
  "linked",
  "listed",
  "literate",
  "lithic",
  "little",
  "littoral",
  "lively",
  "living",
  "local",
  "logical",
  "looming",
  "lovable",
  "loved",
  "lovely",
  "loving",
  "lowland",
  "loyal",
  "lucid",
  "lucky",
  "luminous",
  "lunar",
  "lush",
  "lustrous",
  "lyric",
  "lyrical",
  "magical",
  "magnetic",
  "majestic",
  "major",
  "manifest",
  "mantled",
  "mapped",
  "marbled",
  "marginal",
  "maritime",
  "masted",
  "matted",
  "measured",
  "medial",
  "median",
  "mellow",
  "melodic",
  "merchant",
  "merciful",
  "meridian",
  "merry",
  "meshed",
  "metallic",
  "metric",
  "midland",
  "mighty",
  "migratory",
  "mindful",
  "minimal",
  "minted",
  "mirrored",
  "mirthful",
  "mixed",
  "mobile",
  "modern",
  "modest",
  "modular",
  "molded",
  "monastic",
  "montane",
  "moral",
  "mossed",
  "mottled",
  "mounted",
  "moved",
  "moving",
  "mulched",
  "musical",
  "muted",
  "mutual",
  "mystic",
  "nacreous",
  "narrow",
  "native",
  "natural",
  "nautical",
  "neat",
  "nested",
  "netted",
  "neutral",
  "new",
  "nice",
  "nimble",
  "noble",
  "nodal",
  "nominal",
  "nonlinear",
  "normal",
  "northern",
  "notable",
  "notched",
  "noted",
  "notional",
  "novel",
  "nucleated",
  "numeric",
  "nurturing",
  "oaken",
  "oblique",
  "oceanic",
  "oddly",
  "offbeat",
  "offset",
  "onward",
  "opaline",
  "open",
  "opposed",
  "optical",
  "optimal",
  "opulent",
  "orbital",
  "orderly",
  "organic",
  "oriented",
  "original",
  "ornate",
  "outdoor",
  "outer",
  "outgoing",
  "outlined",
  "overland",
  "oxidized",
  "pacific",
  "padded",
  "paired",
  "palatial",
  "paneled",
  "panoramic",
  "parallel",
  "parched",
  "partial",
  "pastoral",
  "patched",
  "pathwise",
  "patient",
  "patterned",
  "paved",
  "peaceful",
  "piqued",
  "pedaled",
  "pedigreed",
  "pelagic",
  "peppy",
  "perceptive",
  "perched",
  "periodic",
  "perky",
  "personal",
  "petite",
  "petrified",
  "phased",
  "photonic",
  "pierced",
  "pinned",
  "pivotal",
  "placid",
  "planar",
  "planted",
  "platted",
  "playful",
  "pleasant",
  "pleased",
  "pleated",
  "plenary",
  "plotted",
  "plucky",
  "plumbed",
  "plush",
  "poetic",
  "pointed",
  "poised",
  "polished",
  "polite",
  "pooled",
  "popular",
  "ported",
  "positive",
  "postal",
  "potent",
  "potted",
  "powerful",
  "precious",
  "precise",
  "premium",
  "present",
  "pressed",
  "pretty",
  "primal",
  "prime",
  "printed",
  "prismatic",
  "pristine",
  "private",
  "prized",
  "proactive",
  "probable",
  "probed",
  "profiled",
  "profound",
  "programmed",
  "prolific",
  "prominent",
  "promised",
  "prompt",
  "proper",
  "protected",
  "proud",
  "proven",
  "proximal",
  "prudent",
  "public",
  "pulsed",
  "punchy",
  "punctual",
  "pure",
  "purified",
  "quaint",
  "quality",
  "quarried",
  "queenly",
  "quick",
  "quiet",
  "quilted",
  "quirky",
  "quizzical",
  "quoted",
  "radial",
  "radiant",
  "rafted",
  "raised",
  "rambled",
  "ranged",
  "ranked",
  "rapid",
  "rare",
  "rated",
  "rational",
  "ready",
  "real",
  "reclaimed",
  "recorded",
  "reduced",
  "refined",
  "reflected",
  "regal",
  "regional",
  "relative",
  "relaxed",
  "reliable",
  "relieved",
  "remedial",
  "rendered",
  "renewed",
  "renowned",
  "repeated",
  "reported",
  "reserved",
  "residual",
  "resilient",
  "resinous",
  "resolved",
  "resonant",
  "restful",
  "restored",
  "retinal",
  "revered",
  "revolved",
  "ribbed",
  "rich",
  "ridged",
  "rifted",
  "right",
  "rimmed",
  "rippled",
  "riveted",
  "roaming",
  "robust",
  "romantic",
  "roomy",
  "rooted",
  "rosemary",
  "rosy",
  "rotated",
  "round",
  "rounded",
  "routed",
  "rowed",
  "royal",
  "rugged",
  "ruling",
  "runic",
  "rustic",
  "rutted",
  "sacred",
  "saddled",
  "safe",
  "saintly",
  "salient",
  "salted",
  "sampled",
  "sandy",
  "sane",
  "sapient",
  "savvy",
  "scaled",
  "scenic",
  "scented",
  "schooled",
  "scripted",
  "sculpted",
  "seasonal",
  "sectoral",
  "secure",
  "seeded",
  "select",
  "seminal",
  "senior",
  "sensible",
  "sequenced",
  "serene",
  "settled",
  "sharp",
  "sheer",
  "sheltered",
  "shielded",
  "shifted",
  "shining",
  "shiny",
  "shoaled",
  "shy",
  "sifted",
  "silent",
  "silky",
  "silvered",
  "simple",
  "sincere",
  "sizable",
  "sketched",
  "skilled",
  "slated",
  "sleek",
  "slender",
  "slim",
  "sloped",
  "smart",
  "smiling",
  "smoked",
  "smooth",
  "snappy",
  "snug",
  "soaring",
  "social",
  "socketed",
  "soft",
  "soldered",
  "sole",
  "solemn",
  "solid",
  "sonic",
  "soprano",
  "sorted",
  "soulful",
  "sound",
  "sourced",
  "southern",
  "spanning",
  "special",
  "spectral",
  "speedy",
  "spherical",
  "spiraled",
  "spirited",
  "splendid",
  "spliced",
  "spoken",
  "sporting",
  "spotted",
  "sprightly",
  "square",
  "stacked",
  "staffed",
  "staged",
  "stamped",
  "standard",
  "starred",
  "stately",
  "stationed",
  "steady",
  "stellar",
  "stemmed",
  "stepped",
  "sterling",
  "still",
  "stilled",
  "stippled",
  "stitched",
  "stoic",
  "storied",
  "stout",
  "stratified",
  "streaked",
  "striated",
  "striped",
  "strong",
  "structural",
  "studied",
  "studious",
  "sturdy",
  "stylish",
  "subalpine",
  "subtle",
  "sunlit",
  "sunny",
  "superb",
  "supple",
  "supreme",
  "sure",
  "surfaced",
  "sustained",
  "sweet",
  "swirled",
  "synced",
  "tabletop",
  "tactful",
  "tactile",
  "tailored",
  "talented",
  "tallied",
  "tapered",
  "tasseled",
  "temperate",
] as const;

export const COLORS = [
  "amber",
  "amethyst",
  "apricot",
  "aqua",
  "auburn",
  "azure",
  "beige",
  "bisque",
  "black",
  "blonde",
  "blue",
  "blush",
  "bone",
  "brass",
  "brick",
  "bronze",
  "brown",
  "burgundy",
  "camel",
  "caramel",
  "carmine",
  "celadon",
  "celeste",
  "cerulean",
  "champagne",
  "charcoal",
  "cherry",
  "chestnut",
  "citrine",
  "claret",
  "clay",
  "cobalt",
  "cocoa",
  "copper",
  "coral",
  "cream",
  "crimson",
  "cyan",
  "denim",
  "desert",
  "dusk",
  "emerald",
  "flax",
  "forest",
  "fuchsia",
  "gold",
  "grape",
  "green",
  "grey",
  "hazel",
  "indigo",
  "ivory",
  "jade",
  "jasper",
  "khaki",
  "lapis",
  "lavender",
  "lemon",
  "lilac",
  "lime",
  "magenta",
  "mahogany",
  "mango",
  "maroon",
  "mauve",
  "mint",
  "mocha",
  "moss",
  "mustard",
  "navy",
  "obsidian",
  "ochre",
  "onyx",
  "orange",
] as const;

export const NOUNS = [
  "latte",
  "lava",
  "canary",
  "honey",
  "linen",
  "maple",
  "ginger",
  "frost",
  "fawn",
  "opal",
  "orchid",
  "abalone",
  "acacia",
  "accordion",
  "acorn",
  "acropolis",
  "adder",
  "admiral",
  "albatross",
  "alcove",
  "alder",
  "alley",
  "crystal",
  "almanac",
  "almond",
  "alpaca",
  "amulet",
  "anchor",
  "anchovy",
  "antelope",
  "antler",
  "anvil",
  "apex",
  "apiary",
  "arbor",
  "arcade",
  "arch",
  "archive",
  "arena",
  "armadillo",
  "armoire",
  "arrow",
  "arrowhead",
  "aspen",
  "atlas",
  "attic",
  "aurora",
  "aviary",
  "awning",
  "azalea",
  "badge",
  "badger",
  "balcony",
  "bamboo",
  "bangle",
  "banner",
  "barley",
  "barn",
  "baron",
  "barracks",
  "barrel",
  "basilica",
  "basin",
  "basket",
  "bassoon",
  "basswood",
  "bastion",
  "bay",
  "bazaar",
  "beacon",
  "beam",
  "bear",
  "beetle",
  "bell",
  "bench",
  "beret",
  "bergamot",
  "birch",
  "bison",
  "blackbird",
  "blade",
  "blanket",
  "bloom",
  "bluebell",
  "blueberry",
  "bluebird",
  "bluejay",
  "bluff",
  "boathouse",
  "bobcat",
  "bobsled",
  "bolt",
  "bonfire",
  "bonnet",
  "bonsai",
  "bookshelf",
  "borough",
  "boulder",
  "boxwood",
  "bracelet",
  "bramble",
  "branch",
  "bread",
  "breeze",
  "brickwork",
  "bridge",
  "bridle",
  "brig",
  "broadleaf",
  "brook",
  "buckle",
  "buckwheat",
  "bullfrog",
  "bulrush",
  "bunny",
  "bunting",
  "buoy",
  "burrow",
  "buttercup",
  "butterfly",
  "button",
  "byway",
  "cabin",
  "cactus",
  "cairn",
  "camellia",
  "campanile",
  "campus",
  "candelabra",
  "candle",
  "cannon",
  "canopy",
  "canteen",
  "canyon",
  "cape",
  "caper",
  "capstone",
  "capybara",
  "cardinal",
  "cargo",
  "carousel",
  "carriage",
  "cascade",
  "cashmere",
  "castle",
  "catamaran",
  "cattail",
  "cavern",
  "cedar",
  "cellar",
  "centurion",
  "chalet",
  "chameleon",
  "chamomile",
  "chandelier",
  "chapel",
  "charm",
  "cheetah",
  "chickadee",
  "chiffon",
  "chime",
  "chimney",
  "chinchilla",
  "chinook",
  "chipmunk",
  "chronicle",
  "cicada",
  "cipher",
  "circle",
  "circuit",
  "cistern",
  "citadel",
  "clarion",
  "clearing",
  "clematis",
  "cliff",
  "clock",
  "cloister",
  "cloudberry",
  "clover",
  "coast",
  "cobblestone",
  "cockatoo",
  "cocoon",
  "colonnade",
  "columbine",
  "comet",
  "compass",
  "conch",
  "condor",
  "conifer",
  "console",
  "copse",
  "coracle",
  "cormorant",
  "cornet",
  "cornfield",
  "cornflower",
  "corridor",
  "cottage",
  "cougar",
  "court",
  "courtyard",
  "cove",
  "coverlet",
  "coyote",
  "crabapple",
  "cradle",
  "cranberry",
  "crane",
  "crater",
  "creek",
  "crest",
  "cricket",
  "crossbill",
  "crown",
  "cumin",
  "cupola",
  "curlew",
  "currant",
  "cypress",
  "daffodil",
  "dagger",
  "dahlia",
  "dale",
  "damselfly",
  "dandelion",
  "dawn",
  "daybreak",
  "deckle",
  "deepwater",
  "delta",
  "den",
  "dew",
  "dewdrop",
  "dial",
  "diamond",
  "dingo",
  "dipper",
  "dock",
  "doe",
  "dolphin",
  "donkey",
  "dormouse",
  "dove",
  "dovecote",
  "dragon",
  "dragonfly",
  "drake",
  "drawbridge",
  "drift",
  "drum",
  "drumlin",
  "drumstick",
  "dugout",
  "dune",
  "dungeon",
  "dunlin",
  "eagle",
  "eaglet",
  "earthworm",
  "echidna",
  "eclipse",
  "edelweiss",
  "eggplant",
  "egret",
  "eland",
  "elder",
  "elderberry",
  "elderflower",
  "elephants",
  "elk",
  "elm",
  "ember",
  "emblem",
  "emporium",
  "enclave",
  "engine",
  "epoch",
  "ermine",
  "estate",
  "estuary",
  "eyrie",
  "falcon",
  "fallow",
  "fantail",
  "farmstead",
  "fathom",
  "feather",
  "fennel",
  "fern",
  "ferret",
  "ferry",
  "field",
  "fieldfare",
  "fieldstone",
  "fig",
  "figbird",
  "finch",
  "finial",
  "firebrand",
  "firefly",
  "fireside",
  "firethorn",
  "fireweed",
  "fishpond",
  "fjord",
  "flag",
  "flagstone",
  "flame",
  "flamingo",
  "flask",
  "flaxseed",
  "fleet",
  "flicker",
  "flint",
  "float",
  "flock",
  "floodgate",
  "flora",
  "flower",
  "flute",
  "flywheel",
  "foal",
  "fog",
  "font",
  "footbridge",
  "foothill",
  "foothills",
  "footpath",
  "footstep",
  "forge",
  "fort",
  "fossil",
  "fountain",
  "fox",
  "foxglove",
  "foxhound",
  "freesia",
  "frigate",
  "frog",
  "frontier",
  "frostwork",
  "fulcrum",
  "furrow",
  "gadwall",
  "galaxy",
  "galleon",
  "galley",
  "gamebird",
  "gannet",
  "garden",
  "gardenia",
  "gargoyle",
  "garland",
  "garrison",
  "gate",
  "gazebo",
  "gazelle",
  "gear",
  "gem",
  "gemstone",
  "geranium",
  "geyser",
  "ginkgo",
  "glacier",
  "gladiolus",
  "glen",
  "glider",
  "globe",
  "glow",
  "goat",
  "goldfinch",
  "goldfish",
  "gondola",
  "gooseberry",
  "gopher",
  "gorge",
  "goshawk",
  "grain",
  "grange",
  "grasshopper",
  "grassland",
  "greenfinch",
  "greengage",
  "greyhound",
  "grizzly",
  "grotto",
  "groundhog",
  "groundsel",
  "grouse",
  "grove",
  "guardhouse",
  "guava",
  "guild",
  "guildhall",
  "gull",
  "gust",
  "gyrfalcon",
  "habitat",
  "halfmoon",
  "hamlet",
  "hammer",
  "hammock",
  "handcart",
  "handcraft",
  "handrail",
  "harbor",
  "hardwood",
  "hare",
  "harp",
  "harvest",
  "haven",
  "hawk",
  "hawthorn",
  "hayfield",
  "haystacks",
  "hazelnut",
  "hearth",
  "hedge",
  "hedgehog",
  "hedgerow",
  "heirloom",
  "helm",
  "hemlock",
  "hemlocks",
  "heron",
  "heronry",
  "hibiscus",
  "highgate",
  "hill",
  "hillock",
  "hive",
  "hobbit",
  "hollow",
  "holly",
  "homestead",
  "honeybee",
  "hood",
  "horizon",
  "horn",
  "hornbeam",
  "horse",
  "horseshoe",
  "hound",
  "hourglass",
  "hub",
  "hummingbird",
  "hutch",
  "iceberg",
  "igloo",
  "inlet",
  "iris",
  "ironwood",
  "island",
  "isle",
  "ivy",
  "jackal",
  "jackdaw",
  "jaguar",
  "jasmine",
  "jay",
  "jewel",
  "jigsaw",
  "jonquil",
  "junco",
  "jungle",
  "juniper",
  "kayak",
  "keelboat",
  "keep",
  "kelpie",
  "kennel",
  "kernel",
  "kestrel",
  "kettle",
  "key",
  "keystone",
  "kiln",
  "kingbird",
  "kingfisher",
  "kinglet",
  "kiosk",
  "kite",
  "knapweed",
  "knoll",
  "koala",
  "labyrinth",
  "lace",
  "ladybug",
  "lagoon",
  "lake",
  "lakeshore",
  "lamppost",
  "lance",
  "landing",
  "landscape",
  "lantern",
  "lapwing",
  "larch",
  "lark",
  "larkspur",
  "latchkey",
  "lattice",
  "laurel",
  "lawn",
  "leaflet",
  "ledge",
  "legend",
  "lemur",
  "lentil",
  "leopard",
  "lever",
  "lighthouse",
  "lily",
  "linden",
  "linnet",
  "lion",
  "liverwort",
  "lodge",
  "loft",
  "longboat",
  "longbow",
  "lookout",
  "lotus",
  "lynx",
  "lyre",
  "macaw",
  "magnolia",
  "mainmast",
  "mainsail",
  "mallard",
  "mandolin",
  "manor",
  "mantis",
  "mantle",
  "marble",
  "marina",
  "market",
  "marmot",
  "marsh",
  "martin",
  "mast",
  "masthead",
  "maverick",
  "meadow",
  "meadowlark",
  "medal",
  "merganser",
  "merlin",
  "mesa",
  "meteor",
  "mill",
  "millpond",
  "millstone",
  "minnow",
  "mirror",
  "mist",
  "moat",
  "mockingbird",
  "mole",
  "monarch",
  "monastery",
  "moon",
  "moonbeam",
  "moonrise",
  "moonstone",
  "moorhen",
  "moose",
  "mosaic",
  "mossbank",
  "moth",
  "mound",
  "mountain",
  "mouse",
  "mudlark",
  "mulberry",
  "mural",
  "muse",
  "mushroom",
  "musket",
  "mussel",
  "mustang",
  "myrtle",
  "narwhal",
  "nest",
  "nettle",
  "newt",
  "nighthawk",
  "nightingale",
  "nightjar",
  "nimbus",
  "nook",
  "north",
  "notch",
  "notebook",
  "nova",
  "nuthatch",
  "nutmeg",
  "oak",
  "oakmoss",
  "oar",
  "oarlock",
  "oasis",
  "oboe",
  "ocean",
  "octave",
  "omen",
  "orbit",
  "oriole",
  "osprey",
  "otter",
  "outlet",
  "outpost",
  "outrigger",
  "oval",
  "overpass",
  "owl",
  "oxalis",
  "oxbow",
  "oyster",
  "paddle",
  "pagoda",
  "palace",
  "palm",
  "palomino",
  "panther",
  "parcel",
  "park",
  "parrot",
  "partridge",
  "passage",
  "pasture",
  "patch",
  "path",
  "pavilion",
  "paw",
  "pawprint",
  "peahen",
  "peak",
  "pear",
  "pearl",
  "pebble",
  "pelican",
  "pendant",
  "penguin",
  "pepper",
  "perch",
  "peregrine",
  "peridot",
  "petal",
  "petroglyph",
  "pheasant",
  "phoenix",
  "pier",
  "pigeon",
  "pike",
  "pillar",
  "pilot",
  "pine",
  "pineapple",
  "pinecone",
  "pinetree",
  "pinnacle",
  "pioneer",
  "piper",
  "plains",
  "planet",
  "plankton",
  "planter",
  "plateau",
  "plaza",
  "plover",
  "plowshare",
  "plume",
  "pocket",
  "pod",
  "pond",
  "pony",
  "poplar",
  "poppy",
  "porch",
  "porpoise",
  "portal",
  "prairie",
  "primrose",
  "prism",
  "promontory",
  "pronghorn",
  "ptarmigan",
  "pueblo",
  "puffin",
  "pulsar",
  "puma",
  "quahog",
  "quarry",
  "quasar",
  "quay",
  "quill",
  "rabbit",
  "raccoon",
  "rafter",
  "rail",
  "rainbow",
  "raindrop",
  "ram",
  "rampart",
  "ranch",
  "ranger",
  "rapids",
  "raven",
  "ravine",
  "realm",
  "redstart",
  "redwood",
  "reed",
  "reef",
  "reindeer",
  "reserve",
  "ridge",
  "ridgeline",
  "rift",
  "ring",
  "ringdove",
  "ripple",
  "river",
  "riverbank",
  "road",
  "roadrunner",
  "robin",
  "rock",
  "rockfall",
  "roost",
  "rosebud",
  "rosefinch",
  "rotunda",
  "rover",
  "rowboat",
  "runway",
  "saddle",
  "sage",
  "sail",
  "sailboat",
  "salmon",
  "saloon",
  "sanctuary",
  "sandcastle",
  "sandgrouse",
  "sandpiper",
  "sandspur",
  "sandstone",
  "sapling",
  "sapphire",
  "savanna",
  "scaffold",
  "schooner",
  "scroll",
  "seabird",
  "seagull",
  "seahorse",
  "seashell",
  "sequoia",
  "shade",
  "shadow",
  "shamrock",
  "shanty",
  "shearwater",
  "shell",
  "shellfish",
  "shelter",
  "shield",
  "shipyard",
  "shore",
  "shoreline",
  "shrew",
  "shrine",
  "shuttle",
  "sidewinder",
  "signal",
  "silkworm",
  "silverleaf",
  "skimmer",
  "skipper",
  "skylark",
  "sloop",
  "snail",
  "snowbird",
  "snowcap",
  "snowdrop",
  "snowfield",
  "snowfinch",
  "snowflake",
  "snowshoe",
  "solar",
  "solstice",
  "songbird",
  "sparrow",
  "sparrowhawk",
  "spear",
  "sphinx",
  "spider",
  "spiderweb",
  "spire",
  "spring",
  "sprout",
  "spruce",
  "spur",
  "squirrel",
  "stable",
  "stag",
  "stagecoach",
  "star",
  "starfish",
  "starlights",
  "starling",
  "station",
  "steamboat",
  "steeple",
  "steppe",
  "stiletto",
  "stilt",
  "stone",
  "stonefly",
  "stonewall",
  "stonework",
  "storehouse",
  "stork",
  "strait",
  "strand",
  "stream",
  "streambed",
  "sturgeon",
  "summit",
  "sunbeam",
  "sundew",
  "sundial",
  "sunflower",
  "sunrise",
  "sunstone",
  "surfboard",
  "swallow",
  "swallowtail",
  "swan",
  "swift",
  "sword",
  "swordfish",
  "sycamore",
  "sycamores",
  "table",
  "talisman",
  "talon",
  "tambourine",
  "tanbark",
  "tapestry",
  "tarn",
  "teahouse",
  "telescope",
  "temple",
  "terrace",
  "thatchwork",
  "thistle",
  "thorn",
  "thornbush",
  "thrush",
  "thunderbird",
  "thyme",
  "tide",
  "tiger",
  "timber",
  "timberline",
  "tinderbox",
  "torch",
  "tortoise",
  "totem",
  "toucan",
  "tower",
  "trail",
  "trailhead",
  "trapeze",
  "treehouse",
  "treeline",
  "trellis",
  "trestle",
  "tributary",
  "trident",
  "trinket",
  "troubadour",
  "trout",
  "trumpet",
  "tucson",
  "tulip",
  "tundra",
  "tunnel",
  "turnstile",
  "turquoise",
  "turret",
  "turtle",
  "turtledove",
  "tusk",
  "umbrella",
  "undergrowth",
  "unicorn",
  "union",
  "upland",
  "urchin",
  "valley",
  "vane",
  "vault",
  "vellum",
  "veranda",
  "vessel",
  "viaduct",
  "viburnum",
  "villa",
  "village",
  "vine",
  "vineyard",
  "viola",
  "violet",
  "viper",
  "vista",
  "volcano",
  "vole",
  "voyage",
  "vulture",
  "wagon",
  "walrus",
  "warbler",
  "ward",
  "warren",
  "waterbird",
  "watercress",
  "waterfall",
  "watershed",
  "waterwheel",
  "weasel",
  "weathervane",
  "wellspring",
  "whale",
  "wharf",
  "wheatfield",
  "wheel",
  "whippoorwill",
  "whistle",
  "wildcat",
  "wildflower",
  "willow",
  "windchime",
  "windhover",
  "windmill",
  "windrose",
  "wing",
  "wintergreen",
  "wolf",
  "wolfhound",
  "wolverine",
  "woodlands",
  "woodlark",
  "woodpecker",
  "woodpile",
  "woodsmoke",
  "woolsack",
  "wren",
  "wristband",
  "yacht",
  "yak",
  "yarrow",
  "yearbook",
  "yearling",
  "yew",
  "zeal",
] as const;
